/// <reference path="../../types/signalr.d.ts" />

namespace SP {
    export class VibrateItem {
        lastplay: number;

        async play(vibrateTime: number) {
            //min 50ms interval for sounds
            var now = performance.now();
            if (now - this.lastplay < 10) return;
            this.lastplay = now;

            window.navigator?.vibrate(vibrateTime);
        }
    }
}